import React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/lab/Skeleton';

const LoadingState = () => {
  return (
    <Box borderRadius="4px" overflow="hidden" width="126px">
      <Skeleton variant="rectangular" height={10} width={130} animation="wave" />
    </Box>
  );
};

export default LoadingState;
